import { render, staticRenderFns } from "./ScreenSizeSelector.vue?vue&type=template&id=1f93af0c&"
import script from "./ScreenSizeSelector.vue?vue&type=script&lang=js&"
export * from "./ScreenSizeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports